module.exports = __webpack_public_path__ + "static/media/400138_01.9e0ccb3f.png";